import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getLogsByType } from "./actions";

export const loggerEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = loggerEntityAdapter.getInitialState({
  modals: {},
});

export const loggerSlice = createSlice({
  name: "logger",
  initialState: initialState,
  reducers: {
    showActivityLogsModal: (state, action) => {
      state.modals.activityLogsModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLogsByType.fulfilled, (state, action) => {
      if (action.payload.success) {
        loggerEntityAdapter.setAll(state, action.payload.data);
      } else {
        loggerEntityAdapter.setAll(state, []);
      }
    });
  },
});

export const { showActivityLogsModal } = loggerSlice.actions;

export default loggerSlice.reducer;
